import React from 'react';
import { MapPin, Phone, MessageCircle, Stethoscope } from 'lucide-react';
import { BUSINESS_NAME, WA_LINK } from '../lib/constants';
export function Footer() {
  return <footer className="bg-slate-900 py-12 text-slate-300" data-id="element-33">
      <div className="container mx-auto px-4 md:px-6" data-id="element-34">
        <div className="grid gap-8 md:grid-cols-2 lg:grid-cols-4" data-id="element-35">
          <div data-id="element-36">
            <div className="mb-4 flex items-center gap-2 text-white" data-id="element-37">
              <Stethoscope size={24} data-id="element-38" />
              <span className="text-lg font-semibold" data-id="element-39">{BUSINESS_NAME}</span>
            </div>
            <p className="mb-4 text-sm text-slate-400" data-id="element-40">
              Atención dental clara, rápida y enfocada en solucionar.
              Orientación directa sin vueltas innecesarias.
            </p>
          </div>

          <div data-id="element-41">
            <h3 className="mb-4 text-sm font-semibold uppercase tracking-wider text-white" data-id="element-42">
              Contacto
            </h3>
            <ul className="space-y-3 text-sm" data-id="element-43">
              <li data-id="element-44">
                <a href={WA_LINK} target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 transition-colors hover:text-brand-accent" data-id="element-45">
                  <MessageCircle size={18} data-id="element-46" />
                  <span data-id="element-47">WhatsApp Directo</span>
                </a>
              </li>
              <li className="flex items-center gap-2" data-id="element-48">
                <Phone size={18} data-id="element-49" />
                <span data-id="element-50">+56 9 9508 3900</span>
              </li>
            </ul>
          </div>

          <div data-id="element-51">
            <h3 className="mb-4 text-sm font-semibold uppercase tracking-wider text-white" data-id="element-52">
              Ubicación
            </h3>
            <ul className="space-y-3 text-sm" data-id="element-53">
              <li className="flex items-start gap-2" data-id="element-54">
                <MapPin size={18} className="mt-0.5 shrink-0" data-id="element-55" />
                <span data-id="element-56">
                  [Ciudad / Comuna]
                  <br data-id="element-57" />
                  Atención previa coordinación
                </span>
              </li>
            </ul>
          </div>

          <div data-id="element-58">
            <h3 className="mb-4 text-sm font-semibold uppercase tracking-wider text-white" data-id="element-59">
              Profesional
            </h3>
            <p className="text-sm" data-id="element-60">Raymon Arriagada</p>
          </div>
        </div>

        <div className="mt-12 border-t border-slate-800 pt-8 text-center text-sm text-slate-500" data-id="element-61">
          <p data-id="element-62">
            &copy; {new Date().getFullYear()} {BUSINESS_NAME}. Todos los
            derechos reservados.
          </p>
        </div>
      </div>
    </footer>;
}